import {
	cartDetailsActions,
	cartDetailsSelectors,
} from 'modules/api/market/cart/detailsModule';
import { put, select } from 'redux-saga/effects';
import invalidateCartQuery from 'modules/queries/market/cart/invalidateCartQuery';

/** @returns {import('@liquidweb-dev/club-sauce/public/market/cart/index.raw').LWApiPublicMarketCartDetailsResultRawI} */
function* mergeOldCartWithNew({ newCartPortion }) {
	const oldCartDetails = yield select(cartDetailsSelectors.getNativeData);
	const newCartDetails = { ...oldCartDetails, ...newCartPortion };

	yield put(cartDetailsActions.override(newCartDetails));

	// Invalidate React Query cart data to keep it in sync with Redux
	invalidateCartQuery();

	return newCartDetails;
}

export default mergeOldCartWithNew;
